import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Events/MembersMeeting/components/SectionArticles/SectionArticles.module.scss';

const cn = classNames.bind(styles);

const SectionArticles = (): ReactElement => {
  return (
    <section className={cn('articles')}>
      <div className={cn('container')}>
        <div className={cn('articles__content')}>
          <div className={cn('articles__description')}>
            <p className={cn('articles__description-title')}>description</p>
            <div className={cn('articles__description-content')}>
              <div className={cn('articles__description-box')}>
                <p className={cn('articles__description-text')}>
                  Join us each month for our virtual members meeting. In the meeting you will hear the latest DFA
                  updates, business insights and trending industry news. This monthly meeting format also provides an
                  opportunity for members to raise questions and provide feedback on enhancements to the DFA
                  programme.
                </p>
              </div>
              <div className={cn('articles__description-box')}>
                {/* <p className="article-section__description-text">
                  We host 2 sessions each month to ensure that no matter what time zone you're in there is a slot
                  accessible for you.
                </p> */}
                <p className={cn('articles__description-text')}>
                  <span>
                    The next meetings are scheduled on <span className="new-text--bold">19 February 2026</span>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionArticles;